// Old docs slug → current slug, for articles that moved (plan
// 2026-10-13-docs-sidebar-groups-within-a-submenu).
//
// PERMANENT. Old slugs live where we cannot rewrite them: assistant answers
// stored in conversations (search_docs tells the model to cite /docs/<slug>),
// customer bookmarks, tabs on a previous bundle, and slugs an MCP client
// remembers and passes to read_doc. Never delete an entry.
//
// THE DATA LIVES IN `docs/_redirects.json` (next to the articles), not here:
// the backend reads the same file from its docs_bundle/ copy to resolve old
// slugs in the MCP `read_doc` tool (plan 2026-10-13-docs-readable-over-mcp).
// One map, two readers — add a moved article's row THERE. JSON has no comments,
// so the rules live here.
//
// Rules (validateRedirects, run by the manifest, validate-docs and a test):
// every target is a live slug, no source is a live slug, no chains. A test also
// asserts every slug in `__fixtures__/slugs-2026-10-13.json` is live or a key
// here, so a moved article without an entry fails red.
//
// Relative imports only (this file is loaded by the tsx validator script).

import redirects from "../../docs/_redirects.json";

export const DOC_REDIRECTS: Readonly<Record<string, string>> = redirects;

export function validateRedirects(liveSlugs: ReadonlySet<string>): void {
  const problems: string[] = [];
  for (const [from, to] of Object.entries(DOC_REDIRECTS)) {
    if (liveSlugs.has(from)) problems.push(`"${from}" is still a live article — remove the redirect or the article`);
    if (!liveSlugs.has(to)) problems.push(`"${from}" → "${to}": target is not a live article`);
    if (to in DOC_REDIRECTS) problems.push(`"${from}" → "${to}": chained — point it at the final slug`);
  }
  if (problems.length > 0) {
    throw new Error(`[docs] DOC_REDIRECTS (docs/_redirects.json):\n  ${problems.join("\n  ")}`);
  }
}
